import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import PromisePolyfill from 'promise-polyfill';
import localforage from 'localforage';

if (!window.Promise) window.Promise = PromisePolyfill;

localforage.config({
  name: 'flashcard_pc_editor',
  storeName: 'store',
  description: 'A persistent store for where session-to-session data is stored -- no personal information should be saved'
});

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js